// 3_pages/ordering_process_0_repeating.js
// Shared checkout logic (runs on every ordering-process step): builds the cart
// summary wrapper and fetches each cart product's image from its product page.

export function init() {
	if (!document.body.classList.contains("ordering-process")) return;

	document.addEventListener("DOMContentLoaded", function () {
		createWrapperForSummary();
		fetchImagesOfProductsInCart();
		insertStoredGiftImage();
	});

	createWrapperForSummary();
	insertStoredGiftImage();
}

async function fetchImagesOfProductsInCart() {
	const itemNames = document.querySelectorAll(".cart-item .cart-item-name");
	if (!itemNames) return;

	itemNames.forEach(async (itemName) => {
		const productLink = itemName.querySelector("a");
		if (!productLink) return;

		const imageBlock = document.createElement("div");
		imageBlock.classList.add("image-block");
		itemName.parentElement.prepend(imageBlock);

		const productUrl = productLink.href;

		try {
			const response = await fetch(productUrl);
			/* let response = await fetch(window.location.origin + productUrl); */

			if (!response.ok) throw new Error("Network response was not ok");

			const html = await response.text();

			// Parse the HTML string into a document
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");

			// Get the image element
			const img = doc.querySelector(".p-main-image > img");

			if (img) {
				// Clone the image so it can be used in the current DOM
				const newImg = document.createElement("img");
				newImg.src = img.src.replace("/big/", "/detail/");
				newImg.alt = img.alt || "";

				// Prepend to itemName
				itemName.parentElement.querySelector(".image-block").append(newImg);
			}
		} catch (error) {
			console.error("There has been a problem with your fetch operation:", error);
		}
	});
}

function createWrapperForSummary() {
	const cartSummary = document.querySelector("#checkoutSidebar .cart-content");
	if (!cartSummary) return;

	const cartSummaryPrevious = document.querySelector(".cart-summary-wrapper");

	let summaryWrapper = document.createElement("div");
	summaryWrapper.classList.add("cart-summary-wrapper");
	if (!cartSummaryPrevious) {
		cartSummary.appendChild(summaryWrapper);
	}
	if (cartSummaryPrevious) {
		summaryWrapper = cartSummaryPrevious;
	}

	const shippingBillingSummary = document.querySelector("#shipping-billing-summary");

	const recapitulationSingles = document.querySelectorAll(".recapitulation-single");
	recapitulationSingles.forEach((element) => {
		if (shippingBillingSummary) {
			if (element.classList.contains("recapitulation-shipping-billing")) {
				shippingBillingSummary.appendChild(element);
				return;
			}
		}
		summaryWrapper.appendChild(element);
	});

	const orderSummaryHelper = document.querySelector(".order-summary-item.helper");
	if (orderSummaryHelper) {
		summaryWrapper.appendChild(orderSummaryHelper);
	}

	const orderPriceSummary = document.querySelector(".order-summary-item.price");
	if (orderPriceSummary) {
		summaryWrapper.appendChild(orderPriceSummary);
	}

	const nextStep = document.querySelector(".next-step");
	if (nextStep) {
		summaryWrapper.appendChild(nextStep);

		const consents = document.querySelectorAll(".consents");
		if (consents && consents.length > 0) {
			consents.forEach((consent) => {
				nextStep.appendChild(consent);
			});
		}
	}
}

const SELECTED_GIFT_STORAGE_KEY = "natSelectedGift";

function normalizeGiftName(name) {
	return name?.replace(/\s+/g, " ").trim() || "";
}

function extractGiftFromItem(item, selectedInput) {
	if (!item) return null;
	const img = item.querySelector(".free-gifts-img-hover img") || item.querySelector(".free-gifts-img img");
	if (!img) return null;
	return {
		code: item.getAttribute("data-free-gift-id") || selectedInput?.value || "",
		src: img.getAttribute("data-src") || img.currentSrc || img.src,
		alt: img.alt || "",
		name: normalizeGiftName(item.querySelector(".free-gift-name")?.textContent),
	};
}

function extractSelectedGift(root) {
	const form = root.querySelector(".free-gifts-wrapper form");
	if (!form) return null;
	const selectedInput = form.querySelector('input[name="codeId"]:checked');
	const selectedItem = selectedInput?.closest("li") || form.querySelector("li.active");
	return extractGiftFromItem(selectedItem, selectedInput);
}

export function storeSelectedGiftImage() {
	const gift = extractSelectedGift(document);
	if (!gift) {
		if (document.querySelector(".free-gifts-wrapper form")) {
			localStorage.removeItem(SELECTED_GIFT_STORAGE_KEY);
		}
		return;
	}
	localStorage.setItem(SELECTED_GIFT_STORAGE_KEY, JSON.stringify(gift));
}

function readStoredGift() {
	try {
		return JSON.parse(localStorage.getItem(SELECTED_GIFT_STORAGE_KEY));
	} catch (error) {
		return null;
	}
}

function getKosikFetchUrl() {
	const kosikUrl = window.NAT.translations("kosikUrl");
	try {
		const url = new URL(kosikUrl, window.location.origin);
		if (url.origin === window.location.origin) return url.href;
		return url.pathname;
	} catch (error) {
		return kosikUrl;
	}
}

async function fetchSelectedGiftFromCart() {
	const kosikUrl = getKosikFetchUrl();
	if (!kosikUrl) return null;
	try {
		const response = await fetch(kosikUrl);
		if (!response.ok) throw new Error("Network response was not ok");
		const html = await response.text();
		const doc = new DOMParser().parseFromString(html, "text/html");
		return extractSelectedGift(doc);
	} catch (error) {
		console.error("There has been a problem with your fetch operation:", error);
		return null;
	}
}

function prependGiftImage(itemName, gift, recapName) {
	const cartItem = itemName.parentElement;
	if (!cartItem || cartItem.querySelector(":scope > .image-block")) return;
	const imageBlock = document.createElement("div");
	imageBlock.classList.add("image-block");
	const img = document.createElement("img");
	img.src = gift.src;
	img.alt = gift.alt || recapName || "";
	imageBlock.appendChild(img);
	cartItem.prepend(imageBlock);
}

async function insertStoredGiftImage() {
	const giftNames = document.querySelectorAll(".cart-item.cart-item-gift .cart-item-name");
	if (!giftNames.length) return;

	let stored = readStoredGift();
	if (!stored?.src) {
		stored = await fetchSelectedGiftFromCart();
		if (stored?.src) {
			localStorage.setItem(SELECTED_GIFT_STORAGE_KEY, JSON.stringify(stored));
		}
	}
	if (!stored?.src) return;

	const storedName = normalizeGiftName(stored.name);

	giftNames.forEach((itemName) => {
		const recapName = normalizeGiftName(itemName.querySelector("[data-testid='recapItemName']")?.textContent);
		if (storedName && recapName && storedName !== recapName && giftNames.length > 1) return;
		prependGiftImage(itemName, stored, recapName);
	});
}
